<div role="document" class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h2 id="prep-file-heading">Créer un Display</h2>
    </div>
    <div class="modal-body">
      <div class="modal-body">
        <form class="col-10" name="userCreateForm" role="form" novalidate #f="ngForm" (ngSubmit)="valid(f.form) && onSubmit()"
            [formGroup]="userCreateForm">
            <ng-container *ngIf="this.authenSer.isSupperAdmin">
              <div class="form-group ">Saisissez un tenant :
              <ng-select name="selectedVar" dropdownPosition='bottom' formControlName="tenantId" [items]="tenants"
                [ngClass]="{ 'forminput-invalid':f.submitted && userCreateForm?.controls?.customerId?.errors }"
                placeHolder="Tenant" [multiple]="false" [bindLabel]="'companyName'" [closeOnSelect]="true"
                bindValue="id" [clearable]="false">
              </ng-select>
            </div>
            </ng-container>

            <div class="form-group mb-2">
                <label for="label">Label</label>
                <input type="text" class="form-control" id="label" name="label" [ngClass]="{ 'forminput-invalid':
                f.submitted && userCreateForm?.controls?.label?.errors != null}" formControlName="label"/>
                <div *ngIf="f.submitted && userCreateForm?.controls?.label?.errors" class="text-danger">
                  champ Obligatoire
                </div>
              <div >
                <label class="form-control-label" for="adresse">Adresse : </label>
               <app-adresse (setAddress)="getAddress($event)" adressType="geocode"></app-adresse>
              </div>
            </div>
            <div class="form-group mb-2">
              <label for="label">Marque</label>
              <input type="text" class="form-control" id="brand" name="brand" [ngClass]="{ 'forminput-invalid':
              f.submitted && userCreateForm?.controls?.brand?.errors != null}" formControlName="brand"/>
              <div *ngIf="f.submitted && userCreateForm?.controls?.brand?.errors" class="text-danger">
                champ Obligatoire
              </div>
          </div>
          <div class="form-group mb-2">
            <label for="label">IP</label>
            <input type="text" class="form-control" id="ip" name="ip" [ngClass]="{ 'forminput-invalid':
            f.submitted && userCreateForm?.controls?.ip?.errors != null}" formControlName="ip"/>
            <div *ngIf="f.submitted && userCreateForm?.controls?.ip?.errors" class="text-danger">
              champ Obligatoire
            </div>
        </div>
        <div class="form-group mb-2">
          <label for="label">Port</label>
          <input type="text" class="form-control" id="port" name="port" [ngClass]="{ 'forminput-invalid':
          f.submitted && userCreateForm?.controls?.port?.errors != null}" formControlName="port"/>
            <div *ngIf="f.submitted && userCreateForm?.controls?.port?.errors" class="text-danger">
              champ Obligatoire
            </div>
        </div>
        <div class="form-group mb-2">
          <label for="label">Login</label>
          <input type="text" class="form-control" id="username" name="username" [ngClass]="{ 'forminput-invalid':
          f.submitted && userCreateForm?.controls?.username?.errors != null}" formControlName="username"/>
            <div *ngIf="f.submitted && userCreateForm?.controls?.username?.errors" class="text-danger">
              champ Obligatoire
            </div>
        </div>
        <div class="form-group mb-2">
          <label for="label">Password</label>
          <input type="text" class="form-control" id="port" name="password" [ngClass]="{ 'forminput-invalid':
          f.submitted && userCreateForm?.controls?.password?.errors != null}" formControlName="password"/>
            <div *ngIf="f.submitted && userCreateForm?.controls?.password?.errors" class="text-danger">
              champ Obligatoire
            </div>
        </div>
        <div class="form-group mb-2">
          <section class="example-section">
            <mat-slide-toggle
                class="example-margin"
                formControlName= "active" > Actif
            </mat-slide-toggle>
          </section>
        </div>
        <div class="form-group mb-2">
          <section class="example-section">
            <mat-slide-toggle
                class="example-margin"
                formControlName= "automatic" >Afficher Automatiquement
            </mat-slide-toggle>
          </section>
        </div>
            <div class="m-2">
                <button type="button" id="cancel-save" class="btn btn-secondary" data-dismiss="modal"
                    (click)="close();">
                    &nbsp;<span>Annuler</span>
                </button>

                &nbsp;&nbsp;
                <button type="submit" id="save-entity" class="btn btn-indigo button titre">
                    &nbsp;<span>Valider</span>
                </button>
            </div>
        </form>
    </div>
</div>
</div>
